import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import JSZip from 'jszip';
import 'moment'
import 'datatables.net-bs4'
import 'datatables.net-buttons-bs4'
import 'datatables.net-buttons/js/buttons.html5.js'
import 'datatables.net-responsive-bs4'
import 'datatables.net-plugins/sorting/datetime-moment'
import french from 'datatables.net-plugins/i18n/French.lang'
import 'ion-rangeslider'


import $ from 'jquery'
import './style.scss'

window.JSZip = JSZip;
pdfMake.vfs = pdfFonts.pdfMake.vfs;

$(document).ready( function () {
    $.fn.dataTable.moment( 'DD MMMM YYYY', 'fr');
    $('.datatableAnnonce').DataTable({
        dom: 'Bfrtip',
        //responsive: true,
        language:  french,
        buttons: [
            {
                extend: 'copyHtml5',
                exportOptions: {
                    columns: [0, 1, 2, 3]
                }
            },
            {
                extend: 'excelHtml5',
                exportOptions: {
                    columns: [0, 1, 2, 3]
                }
            },
            {
                extend: 'pdf',
                exportOptions: {
                    columns: [0, 1, 2, 3]
                }
            },
        ]
    });

    $('.datatableContact').DataTable({
        dom: 'Bfrtip',
        //responsive: true,
        language:  french,
        buttons: [
            {
                extend: 'copyHtml5',
                exportOptions: {
                    columns: [0, 1, 2, 3, 4, 5]
                }
            },
            {
                extend: 'excelHtml5',
                exportOptions: {
                    columns: [0, 1, 2, 3, 4, 5]
                }
            },
            {
                extend: 'pdf',
                exportOptions: {
                    columns: [0, 1, 2, 3, 4, 5]
                }
            },
        ]
    });
} );